import { PayloadAction } from "@reduxjs/toolkit";
import { UpsellState } from "../../models/UpsellsState";
import { CreateUpsellPayload } from "../../payload/CreateUpsell/CreateUpsellPayload";

const createAdditionalFetch = (state: UpsellState, action: PayloadAction<CreateUpsellPayload>) => {
    state.isLoading = true;
}

export default createAdditionalFetch;